<!-- loader.component.html -->
<div class="progress-loader loader" [hidden]="!loading">
    <div class="spinner">
        <div class="spinner-border text-dark"></div>
        <h5>Please Wait...</h5>
    </div>

</div>
